export default __webpack_public_path__ + "static/media/cross.937fbe82.svg";